import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../store/language-context';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import EventTimer from './EventTimer';
import EventInfoCard from './EventInfoCard';
import SpeakersCarousel from './SpeakersCarousel';
import LocalSpeakerCard from './LocalSpeakerCard';
import AwardsSection from './AwardsSection';
import PresentationsCarousel from './PresentationsCarousel';
import RegistrationForm from './RegistrationForm';
import eventimg from "../../assets/used-icons/event-bg.png"
import Breadcrumb from '../Pages/Breadcrumb';
const Event = () => {
    const { t } = useTranslation();
    const { language, URL } = useLanguage();
    const { id } = useParams();
    const [eventData, setEventData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [timeLeft, setTimeLeft] = useState({days: 0, hours: 0, minutes: 0, seconds: 0});

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString(language === 'ar' ? 'ar-SA' : 'en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    useEffect(() => {
        const fetchEventData = async () => {
            try {
                const response = await axios.get(`http://staging.ivorytraining.com/api/event/36`, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });
                if (response.status === 200) {
                    setEventData(response.data);
                } else {
                    setError(t('custom.err'));
                }
            } catch (err) {
                setError(t('custom.err'));
            } finally {
                setLoading(false);
            }
        };

        fetchEventData();
    }, [URL, id, t]);

    const localSpeakers = eventData?.influencers || [
        {
            name: 'Gena Morgan',
            title: 'Sr.Director, Community Engagement Gsius',
            image: '/path-to-speaker-image-1.jpg'
        },
        {
            name: 'Gena Morgan',
            title: 'Sr.Director, Community Engagement Gsius',
            image: '/path-to-speaker-image-2.jpg'
        },
        {
            name: 'Gena Morgan',
            title: 'Sr.Director, Community Engagement Gsius',
            image: '/path-to-speaker-image-3.jpg'
        },
        {
            name: 'Gena Morgan',
            title: 'Sr.Director, Community Engagement Gsius',
            image: '/path-to-speaker-image-4.jpg'
        }
    ];

    // Calculate remaining time
    useEffect(() => {
        const calculateTimeLeft = () => {
            if (!eventData) return;
            const startDate = new Date(eventData.events.start_date);
            const now = new Date();
            const difference = startDate - now;

            setTimeLeft({
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            });
        };

        calculateTimeLeft();
        const timer = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(timer);
    }, [eventData]);

    const speakers = eventData?.speakers || [
        {
            name: 'Sarah Patel',
            title: 'Director of Procurement',
            company: 'Tesla Inc',
            logo: '/path-to-tesla-logo.svg'
        },
        {
            name: 'Sarah Patel',
            title: 'Director of Procurement',
            company: 'Tesla Inc',
            logo: '/path-to-tesla-logo.svg'
        },
        {
            name: 'Sarah Patel',
            title: 'Director of Procurement',
            company: 'Tesla Inc',
            logo: '/path-to-tesla-logo.svg'
        },
        {
            name: 'Sarah Patel',
            title: 'Director of Procurement',
            company: 'Tesla Inc',
            logo: '/path-to-tesla-logo.svg'
        }
    ];

    const eventInfo = eventData?.events?.cource_objective?.map((obj, index) => ({
        id: index + 1,
        title: `${t('events.objective')} ${index + 1}`,
        description: obj.title
    })) || [
        {
            id: 1,
            title: 'الدورة القادمة',
            description: 'تعرف على المزيد حول دورة المشتريات وسلاسل الإمداد 2025'
        },
        {
            id: 2,
            title: 'استراتيجيات متقدمة',
            description: 'استراتيجيات وتقنيات متقدمة في إدارة المشتريات والعقود'
        },
        {
            id: 3,
            title: 'إدارة المخاطر',
            description: 'تحليل وإدارة المخاطر في سلاسل التوريد والمشتريات'
        },
        {
            id: 4,
            title: 'التواصل مع المتدربين',
            description: 'منصة تفاعلية تتيح التواصل المباشر مع المدربين والخبراء'
        },
        {
            id: 5,
            title: 'الشهادات المهنية',
            description: 'شهادات معتمدة ومعترف بها دولياً في مجال المشتريات'
        }
    ];

    if (loading) {
        return <div>Loading...</div>; // Replace with your loading component
    }

    if (error) {
        return <div>{error}</div>; // Replace with your error component
    }

    return (
        <>
            <Breadcrumb pages={[t("routes.events")]} />
            <div className="flex flex-col min-h-screen">
                {/* Hero Section */}
                <div className="relative h-[600px] w-full">
                    <div className="absolute inset-0" style={{padding: '50px'}}>
                        <img 
                            src={`http://staging.ivorytraining.com/${eventData.events.image}`}
                            alt={eventData.events.name} 
                            className="w-full h-full object-cover"
                            style={{filter: 'brightness(0.8)',borderRadius: '12px'}}
                        />
                    </div>
                    
                    <div className="relative flex flex-col items-center justify-center text-white bg-[#6A2F38]"
                         style={{maxWidth: '750px',padding: '50px',borderRadius: '12px',margin: 'auto',marginTop: '350px'}}>
                        <h1 className={`text-sm font-bold mb-6 text-center text-[#D4AD89] ${language === 'ar' ? 'font-arabic' : ''}`}>
                            {t('events.hero.title')}
                        </h1>
                        
                        <p className={`text-xl md:text-2xl mb-8 text-center max-w-3xl ${language === 'ar' ? 'font-arabic' : ''}`}>
                            {eventData.events.name}
                        </p>

                        <EventTimer 
                            days={timeLeft.days}
                            hours={timeLeft.hours}
                            minutes={timeLeft.minutes}
                            seconds={timeLeft.seconds}
                        />

                        <button className="mt-8 px-8 py-3 bg-[#D4AD89] hover:bg-primary/90 text-white rounded-md transition-colors">
                            {t('events.hero.cta')}
                        </button>
                    </div>
                </div>

                {/* Info Cards Section */}
                <div className="container mx-auto" style={{marginTop: '250px'}}>
                    <h2 className={`text-3xl font-bold text-center mb-12 ${language === 'ar' ? 'font-arabic' : ''}`}>
                        {t('events.infoSection.title')}
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {eventData.events.cource_objective.map((objective, index) => (
                            <EventInfoCard
                                key={index}
                                title={`${t('events.objective')} ${index + 1}`}
                                description={objective.title}
                            />
                        ))}
                    </div>
                </div>

                {/* International Speakers Section */}
                <SpeakersCarousel speakers={speakers} />

                {/* Local Speakers Section */}
                <div className="bg-gray-50 py-16">
                    <div className="container mx-auto px-4">
                        <h2 className="text-3xl font-bold mb-16 text-center">{t('events.localSpeakers.title')}</h2>
                        
                        <div className="relative">
                            {/* Navigation Arrows */}
                            <button 
                                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-primary/10 hover:bg-primary/20 rounded-full p-2"
                                aria-label="Previous slide"
                            >
                                <svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            
                            <button 
                                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-primary/10 hover:bg-primary/20 rounded-full p-2"
                                aria-label="Next slide"
                            >
                                <svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </button>

                            {/* Speakers Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-12">
                                {localSpeakers.map((speaker, index) => (
                                    <LocalSpeakerCard 
                                        key={index}
                                        {...speaker}
                                    />
                                ))}
                            </div>

                            {/* Pagination Dots */}
                            <div className="flex justify-center mt-8 gap-2">
                                {[0, 1, 2].map((dot) => (
                                    <button
                                        key={dot}
                                        className={`w-2 h-2 rounded-full transition-all ${
                                            dot === 0 ? 'bg-primary w-4' : 'bg-primary/50'
                                        }`}
                                        aria-label={`Go to slide ${dot + 1}`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Registration Section */}
                <div className="bg-gray-50 py-16">
                    <div className="container mx-auto px-4">
                        <h2 className={`text-3xl font-bold text-center mb-16 ${language === 'ar' ? 'font-arabic' : ''}`}>
                            {t('events.registration.title')}
                        </h2>
                        <RegistrationForm 
                            requiredFields={eventData.events.field_required}
                            eventId={eventData.events.id}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Event;
